module.exports = __webpack_public_path__ + "img/组 2935.a01aedd2.svg";